/**
 * External Dependencies
 */
import {
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Swal from 'sweetalert2';

import {
  IconCopy,
  IconEdit,
  IconLanguage,
  IconTrashX,
  IconWorldOff,
} from '@tabler/icons';
import Bandiera from '../../../../components/flags';
import { CRUD_ACTION_TYPE } from '../../../../constants/crudActionType';
import FormLingue from './form-lingue';
/**
 * Internal Dependencies
 */

class TabellaLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'nome', title: 'Nome Layout' },
        { name: 'ticker', title: 'Testo Scorrevole' },
        { name: 'header', title: 'Header' },
        { name: 'footer', title: 'Footer' },
        { name: 'lingueTradotte', title: 'Traduzioni attive' },
        { name: 'data_inserimento', title: 'Data Creazione' },
        { name: 'opzioni', title: 'Opzioni' },
      ],
      rows: [],
      filteringStateColumnExtensions: [
        { columnName: 'opzioni', filteringEnabled: false },
        { columnName: 'lingueTradotte', filteringEnabled: false },
      ],
      tableColumnExtension: [
        { columnName: 'nome', align: 'center' },
        { columnName: 'data_inserimento', align: 'center' },
        { columnName: 'opzioni', align: 'center', width: 230 },
      ],
    };
    this.handleChildLingueUnmount = this.handleChildLingueUnmount.bind(this);
  }

  eliminaLayout(id, username) {
    Swal.fire({
      title: 'Sei sicuro?',
      text: 'Vuoi davvero eliminare il layout ' + username + '?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Elimina!',
      cancelButtonText: 'No, Mantieni',
    }).then(result => {
      if (result.value) {
        let body = {
          id: id,
        };
        window.api.monitor.layout
          .elimina(body)
          .then(async res => {
            Swal.fire({
              title: 'Eliminato!',
              text: 'Il layout ' + username + ' è stato eliminato.',
              icon: 'success',
            }).then(() => {
              this.elencoLayout();
            });
          })
          .catch(err => {
            console.log(err);
            Swal.fire(
              'Oops!',
              "C'è stato un problema durante l'eliminazione, riprova più tardi.",
              'error'
            );
          });
      }
    });
  }

  changeFormStatus(id, nome) {
    this.props.status(CRUD_ACTION_TYPE.MODIFICA, 1, id);
  }

  copyLayout(id) {
    this.props.status(CRUD_ACTION_TYPE.COPIA, 1, id);
  }

  handleChildLingueUnmount() {
    this.setState({ renderChildLingue: false }, () => {
      this.elencoLayout();
    });
  }

  elencoLayout() {
    window.api.monitor.layout
      .tabella('/layout/tabella')
      .then(res => {
        let lay = res.data.monitor_layout;
        for (let l of lay) {
          l.ticker = l.ticker != '0' ? '✔' : '❌';
          l.header = l.header != null ? l.header : '❌';
          l.footer = l.footer != null ? l.footer : '❌';
          l.bottoni = l.bottoni != null ? l.bottoni : '❌';
          l.sezioni = l.sezioni != null ? l.sezioni : '❌';
          l.lingueTradotte = [];
          for (let lang of l.lingue) {
            l.lingueTradotte.push(
              <span style={{ marginRight: '2px' }}>
                <Bandiera country={lang} />
              </span>
            );
          }
          if (l.lingueTradotte.length == 0) {
            l.lingueTradotte.push(<IconWorldOff size={20} />);
          }
          l.data_inserimento = moment(l.data_inserimento).format('DD/MM/YYYY');
          l.opzioni = (
            <>
              <Button
                size="sm"
                style={{ marginLeft: '5px' }}
                color="brand"
                className="btn-hover-outline btn-uniform btn-round"
                onClick={() => this.changeFormStatus(l.revision_id, l.nome)}
              >
                <IconEdit size={15} />
              </Button>
              <Button
                size="sm"
                style={{ marginLeft: '5px' }}
                color="brand"
                className="btn-hover-outline btn-uniform btn-round"
                onClick={() => this.copyLayout(l.revision_id)}
              >
                <IconCopy size={15} />
              </Button>
              <Button
                size="sm"
                style={{ marginLeft: '5px' }}
                color="brand"
                className="btn-hover-outline btn-uniform btn-round"
                onClick={() =>
                  this.setState({
                    renderChildLingue: true,
                    selectedLayoutMonitor: l.revision_id,
                  })
                }
              >
                <IconLanguage size={15} />
              </Button>
              <Button
                size="sm"
                style={{ marginLeft: '5px' }}
                color="brand"
                className="btn-hover-outline btn-uniform btn-round"
                onClick={() => this.eliminaLayout(l.revision_id, l.nome)}
              >
                <IconTrashX size={15} />
              </Button>
            </>
          );
        }
        this.setState({
          rows: lay,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.elencoLayout();
  }

  render() {
    const {
      selectedLayoutMonitor,
      rows,
      columns,
      tableColumnExtension,
      filteringStateColumnExtensions,
    } = this.state;

    const {} = this.props;

    return (
      <Paper>
        {this.state.renderChildLingue ? (
          <FormLingue
            unmountMe={this.handleChildLingueUnmount}
            selectedLayoutMonitor={selectedLayoutMonitor}
          />
        ) : null}
        <Grid rows={rows} columns={columns}>
          <SortingState
            defaultSorting={[{ columnName: 'nome', direction: 'asc' }]}
          />
          <IntegratedSorting />
          <FilteringState
            // defaultFilters={defaultFilters}
            columnExtensions={filteringStateColumnExtensions}
          />
          <IntegratedFiltering />
          <PagingState defaultCurrentPage={0} pageSize={5} />
          <IntegratedPaging />
          <Table columnExtensions={tableColumnExtension} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow messages={{ filterPlaceholder: 'Cerca...' }} />
          <PagingPanel />
        </Grid>
      </Paper>
    );
  }
}

export default TabellaLayout;
